import { useEffect, useRef, useState } from "react";
import { MapPin } from "lucide-react";
import { api } from "@/lib/api";

export const SuburbPicker = ({ value, onChange, onPick, state, testId = "suburb-picker", placeholder = "Suburb or postcode", className = "field" }) => {
  const [opts, setOpts] = useState([]);
  const [open, setOpen] = useState(false);
  const timer = useRef();

  useEffect(() => {
    clearTimeout(timer.current);
    if (!open || (value || "").trim().length < 2) return setOpts([]);
    timer.current = setTimeout(() => api.get("/suburbs", { params: { q: value, state } }).then((r) => setOpts(r.data)), 200);
  }, [value, state, open]);

  return (
    <div className="relative">
      <input data-testid={`${testId}-input`} value={value} placeholder={placeholder} className={className} autoComplete="off"
        onChange={(e) => { onChange(e.target.value); setOpen(true); }} onFocus={() => setOpen(true)} onBlur={() => setTimeout(() => setOpen(false), 150)} />
      {open && opts.length > 0 && (
        <ul data-testid={`${testId}-options`} className="absolute left-0 top-full z-30 mt-1 max-h-64 min-w-full w-max max-w-[320px] overflow-y-auto rounded-xl bg-white py-1 text-sm text-[#0f2a33] shadow-xl">
          {opts.map((o) => (
            <li key={`${o.suburb}-${o.postcode}-${o.state}`}>
              <button type="button" data-testid={`${testId}-option-${o.postcode}-${o.suburb.replace(/\s+/g, "-").toLowerCase()}`}
                onMouseDown={(e) => e.preventDefault()} onClick={() => { onPick(o); setOpen(false); }}
                className="flex w-full items-center gap-2 px-4 py-2 text-left hover:bg-slate-100">
                <MapPin className="h-4 w-4 text-slate-400" /> <span className="font-semibold">{o.suburb}</span>
                <span className="text-slate-500">{o.state} {o.postcode}</span>
              </button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};
